import axios from 'axios';
import authHeader from './auth-header';
import UserHelper from '../helpers/user.helper.js';

// Même principe que ton CorridoringService :
// VUE_APP_API_URL doit déjà contenir le préfixe de l’API (ex: "http://localhost:3000/api/")
const API_URL = process.env.VUE_APP_API_URL + 'geofencing/';

class GeofencingService {
    getClientGeofencings(clientId = null, search = null) {
        const cid = clientId ?? UserHelper.getClientId();
        return axios.get(
            API_URL + 'getclientgeofencings/' + cid,
            { params: { search }, headers: authHeader() }
        );
    }

    getGeofencing(geofencingId) {
        return axios.get(API_URL + 'getgeofencing/' + geofencingId, { headers: authHeader() });
    }

    getGeofencingPoints(geofencingId) {
        return axios.get(API_URL + 'getgeofencingpoints/' + geofencingId, { headers: authHeader() });
    }

    create(clientId, name, points) {
        return axios.put(
            API_URL + 'create/' + clientId,
            { name, points },
            { headers: authHeader() }
        );
    }

    updateName(geofencingId, name) {
        return axios.put(
            API_URL + 'update-name/' + geofencingId,
            { name },
            { headers: authHeader() }
        );
    }

    replacePoints(geofencingId, points) {
        return axios.put(
            API_URL + geofencingId + '/points',
            { points },
            { headers: authHeader() }
        );
    }

    delete(geofencingId) {
        return axios.delete(API_URL + 'delete/' + geofencingId, { headers: authHeader() });
    }

    addBalise(geofencingId, baliseId) {
        return axios.put(
            API_URL + 'addbalise/' + geofencingId,
            { baliseId },
            { headers: authHeader() }
        );
    }

    removeBaliseGeofencing(baliseId) {
        return axios.put(
            API_URL + 'removebalisegeofencing/' + baliseId,
            {},
            { headers: authHeader() }
        );
    }
}

export default new GeofencingService();